import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
//import { useTheme } from '@material-ui/core/styles'
import ReactBSAlert from 'react-bootstrap-sweetalert'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Select from '@mui/material/Select'
import MenuItem from '@material-ui/core/MenuItem'
import AdminAPI from 'config/api/AdminAPI'
import LeadPricingTable from 'components/admin/LeadPricingTable'
import { onError } from 'config/lib/errorLib'
import { productOptions, defaultPensionPricing } from 'config/constants/Constants'
import componentStylesDialog from 'assets/theme/components/dialog.js'
import componentStylesForms from 'assets/theme/components/forms.js'
import componentStylesButtons from 'assets/theme/components/button.js'
import moment from 'moment-timezone'

//const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)
const useStylesForms = makeStyles(componentStylesForms)
const useStylesButtons = makeStyles(componentStylesButtons)

const Transition = React.forwardRef(function Transition(props, ref) {
  	return <Slide direction='down' ref={ref} {...props} />
})

export default function DeliveryModal(props) {
	const classes = { ...useStylesDialog(), ...useStylesForms(), ...useStylesButtons() }
  	//const theme = useTheme()
  	const api = new AdminAPI()

    const delivery = props.delivery
    const companies = [...props.companies].sort((a, b) => a.name.localeCompare(b.name))
    const campaigns = props.campaigns
    const sortedProductOptions = [...productOptions].sort((a, b) => a.label.localeCompare(b.label))

    console.log(delivery.startDate)
    console.log(moment(delivery.startDate).format('YYYY-MM-DD'))

    const [company, setCompany] = useState(delivery.companyId)
    const [product] = useState(delivery.product)
    //const [source, setSource] = useState(delivery.source)
    //const [startDate, setStartDate] = useState(moment(delivery.startDate).format('YYYY-MM-DD'))
    const [leadPrice, setLeadPrice] = useState(delivery.leadPrice)
    //const [vatRate, setVatRate] = useState(delivery.vatRate)
    const [allocation, setAllocation] = useState(delivery.allocation)
    const [leadbyteNumber, setLeadbyteNumber] = useState(delivery.leadbyteNumber ? delivery.leadbyteNumber : '')
    const [active, setActive] = useState(delivery.active)
    // while under weekly cap, this buyer takes every lead for the product before normal rules
    const [priority, setPriority] = useState(delivery.priority === true)
    // pensions only: price leads per pension-value band instead of the flat lead price
    const [usePricingTable, setUsePricingTable] = useState(delivery.usePricingTable || false)
    const [pricing, setPricing] = useState(delivery.pricing || defaultPensionPricing)
    const [alert, setAlert] = useState(null)

    function saveDelivery() {
        // warn when variable pricing is being switched on or its table changed —
        // new prices only apply to leads allocated from now on
        const pricingChanged = JSON.stringify(pricing) !== JSON.stringify(delivery.pricing || null)
        if (product === 'pensions' && usePricingTable && (!delivery.usePricingTable || pricingChanged)) {
            setAlert(
                <ReactBSAlert
                    warning
                    showCancel
                    style={{ display: 'block', marginTop: '-100px' }}
                    title='Variable pricing'
                    onConfirm={() => { setAlert(null); updateDelivery() }}
                    onCancel={() => setAlert(null)}
                    confirmBtnBsStyle='primary'
                    confirmBtnText='Save'
                    cancelBtnText='Cancel'
                    btnSize=''
                >
                    Price changes only apply to leads allocated from now on. Already-allocated leads keep their price. Contact Declan if retrospective changes are needed.
                </ReactBSAlert>
            )
            return
        }
        updateDelivery()
    }

    async function updateDelivery() {
        try {
            // let formattedStartDate = new Date(startDate)
            // console.log('formatted start date: ', formattedStartDate)

            try {
                const sendUsePricingTable = product === 'pensions' && usePricingTable === true
                // keep any stored map when the toggle is off so it can be re-enabled later
                const sendPricing = sendUsePricingTable ? pricing : (delivery.pricing || null)
                let updatedDelivery = await api.updateDelivery(delivery.companyId, delivery.product, leadPrice, allocation, leadbyteNumber, active, sendUsePricingTable, sendPricing, priority)
                console.log('delivery: ', updatedDelivery)

                props.updateDelivery(updatedDelivery)
                props.showSuccessAlert('Delivery updated!')
                props.close()
            } catch(e) {
                onError(e)
            }
  		} catch(e) {
  			onError(e)
  		}
    }

    // function updateStartDate(date) {
    //     console.log(date)
    //     setStartDate(date)
    // }

	return (
        <Dialog
            open={props.isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => props.close()}
        >
            {alert}
            <div className={classes.dialogHeader}>
				<Typography
					variant='h5'
					component='h5'
					className={classes.dialogTitle}
				>
					Update Delivery
					{delivery.deliveryMethod && (
						<span style={{
							fontSize: '10px', fontWeight: 700, color: '#fff',
							backgroundColor: delivery.deliveryMethod === 'webhook' ? '#fb6340' : delivery.deliveryMethod === 'email' ? '#f5365c' : '#11cdef',
							padding: '2px 6px', borderRadius: '3px', textTransform: 'uppercase', marginLeft: '8px', verticalAlign: 'middle'
						}}>
							{delivery.deliveryMethod === 'webhook' ? 'Webhook' : delivery.deliveryMethod === 'email' ? 'Email' : 'BD'}
						</span>
					)}
				</Typography>
				<IconButton onClick={() => props.close()}>
					<Clear />
				</IconButton>
			</div>
            <DialogContent>
                <FormGroup>
                    <FormLabel>Company</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                            disabled
                        >
                            {companies.map((company) => {
                                return (
                                    <MenuItem key={company.companyId} value={company.companyId}>{company.name}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Product</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={product}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                            disabled
                        >
                            {sortedProductOptions.map((option) => {
                                return (
                                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </FormGroup>
                {/*
                <FormGroup>
                    <FormLabel>Source</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={source}
                            onChange={(e) => setSource(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value='insureyourincome.ie'>insureyourincome.ie</MenuItem>
                            <MenuItem value='lifecompare.ie'>lifecompare.ie</MenuItem>
                            <MenuItem value='unlockyourpension.ie'>unlockyourpension.ie</MenuItem>
                            <MenuItem value='nationalpensionhelpline.ie'>nationalpensionhelpline.ie</MenuItem>
                            <MenuItem value='stoppayingtoomuch.ie'>stoppayingtoomuch.ie</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                */}
                {/*
				<FormGroup>
                    <FormLabel>Start Date</FormLabel>
                    <OutlinedInput
                        fullWidth
                        type='date'
                        value={startDate}
                        defaultValue={startDate}
                        onChange={(e) => updateStartDate(e.target.value)}
                    />
                </FormGroup>
                */}
                <FormGroup>
                  	<FormLabel>Lead Price (€){product === 'pensions' && usePricingTable ? ' — not used while variable pricing is on' : ''}</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={leadPrice}
                    	onChange={(e) => setLeadPrice(e.target.value)}
                        disabled={product === 'pensions' && usePricingTable === true}
                  	/>
                </FormGroup>
                {product === 'pensions' && (
                    <FormGroup>
                        <FormLabel>Variable Pricing</FormLabel>
                        <FormControl variant='outlined' fullWidth>
                            <Select
                                multiple={false}
                                value={usePricingTable}
                                onChange={(e) => setUsePricingTable(e.target.value)}
                                input={<OutlinedInput />}
                                style={{marginBottom: '0.5rem'}}
                            >
                                <MenuItem value={false}>No — flat lead price</MenuItem>
                                <MenuItem value={true}>Yes — price per pension value</MenuItem>
                            </Select>
                        </FormControl>
                        {usePricingTable === true && (
                            <LeadPricingTable
                                details={pricing}
                                updateDetails={(updatedPricing) => setPricing(updatedPricing)}
                            />
                        )}
                    </FormGroup>
                )}
                {/*
                <FormGroup>
                    <FormLabel>VAT Rate</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={vatRate}
                            onChange={(e) => setVatRate(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value='Inclusive'>23% Inclusive (included in lead price)</MenuItem>
                            <MenuItem value='Exclusive'>23% Exclusive (not included in lead price)</MenuItem>
                            <MenuItem value='None'>0% (no VAT)</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                */}
                <FormGroup>
                  	<FormLabel>Allocation</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={allocation}
                    	onChange={(e) => setAllocation(e.target.value)}
                  	/>
                </FormGroup>
                {/*
                <FormGroup>
                  	<FormLabel>Leadbyte Number</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={leadbyteNumber}
                    	onChange={(e) => setLeadbyteNumber(e.target.value)}
                  	/>
                </FormGroup>
                */}
                <FormGroup>
                    <FormLabel>Active</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={active}
                            onChange={(e) => setActive(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Priority</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        While under weekly cap, this buyer receives every lead for the product before the product's normal allocation rules. Once at cap, allocation reverts to those rules.
                    </Box>
                </FormGroup>
			</DialogContent>
            <DialogActions>
                <Box width='100%' display='flex' justifyContent='space-between'>
                    <Button onClick={() => props.close()} color='primary'>
                        Close
                    </Button>
                    <Box>
                        <Box display='inline-block' marginRight='0.5rem'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => saveDelivery()}
                            >
                                Save
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </DialogActions>
        </Dialog>
	)
}